import { Fragment } from "react";
import StaedteError from "./Error";

export default function Partners(params) {

    const partners = params.data;

    let errorOccured = undefined !== partners.errors;
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <Fragment>
                <StaedteError />
            </Fragment>
        );
    } else if ( undefined === partners || 0 === partners.length ) {
        return;
    }

    return(
    
        <div className="staedte-partner-container">

            <p className="staedte-partner-header">
                <b>
                    {window.staedteFrontendShortcodeData.i18n.partner}
                </b>
            </p>

            <div className="staedte-partner-wrapper">
                {
                    partners.map(
                        (partner,index) => {
                            return(

                                <div key={index} className="staedte-partner-card text-decoration-none">
                                    <div className="card">

                                        <div
                                            className="staedte-partner-img-wrapper"
                                        >
                                            {/* TODO: Add deault img for partners with no image */}
                                            <img
                                                className={'staedte-partner-img'}
                                                alt={partner.partner} src={`https://bierbachelor.com/logos/partner/${partner.grafik}`}
                                            />
                                        </div>

                                    </div>
                                </div>

                            );
                        }
                    )
                }
            </div>

        </div>

    ); 
}